module.exports = __webpack_public_path__ + "4dc0cadef2f26f2671e9d381b726e753.png";